var CollapsibleLinklist = function() {

  function applyCollapsible() {
    const $links = $(".collapse__link");
    const $elems = $(".collapse__container");

    for (let i = 0; i < $links.length; i += 1) {
      const li = $links[i];
      const id = $(li).attr("href").replace("#", "");
      $(li).attr("aria-expanded", "false").attr("data-toggle", "collapse").attr("aria-controls", id);
    }

    for (let i = 0; i < $elems.length; i += 1) {
      const el = $elems[i];
      $(el).addClass("collapse multi-collapse");
    }
  }

  function removeCollapsible() {
    const $links = $(".collapse__link");
    const $elems = $(".collapse__container");

    for (let i = 0; i < $links.length; i += 1) {
      const li = $links[i];
      $(li).attr("aria-expanded", "true").removeAttr("data-toggle").removeAttr("aria-controls");
    }

    for (let i = 0; i < $elems.length; i += 1) {
      const el = $elems[i];
      $(el).removeClass("collapse multi-collapse");
    }
  }

  function init(breakpoint) {
    if (window.innerWidth < breakpoint) {
      applyCollapsible();
    } else {
      removeCollapsible();
    }
  }

  return {
    init: init
  };

}();

export { CollapsibleLinklist };
